import Stack from "@mui/material/Stack";
import { TouchpointNotification } from "services/types/notifications";
import Typography from "@mui/material/Typography";
import ListItemText from "@mui/material/ListItemText";
import * as React from "react";
import Link from "@mui/material/Link";

const TouchpointNotificationComponent = ({
  title,
  description,
  extra,
}: TouchpointNotification) => {
  const { error, patient_id, touchpoint_id } = extra;
  return (
    <ListItemText
      primary={title}
      secondary={
        <Stack component="span" gap={0.5}>
          <Typography component="span" sx={{ whiteSpace: "pre-line" }}>
            {description}
          </Typography>
          {patient_id && (
            <Link
              href={`/patients/${patient_id}/touchpoints/${touchpoint_id}/edit`}
              underline="hover"
            >
              View Patient Touchpoint
            </Link>
          )}
          {error && (
            <Typography component="span" sx={{ whiteSpace: "pre-line" }}>
              {error}
            </Typography>
          )}
        </Stack>
      }
    />
  );
};

export default TouchpointNotificationComponent;
